// Port of api/fuel/app/classes/insights/size/cluster.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'cluster',
	types: [Constants.TYPE_USER],
	insight: false,
	default_: false,
	detail: ['cluster'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var index = Array.isArray(vars.index) ? vars.index : []
		if (!owner.get_count_collection() || !index.length) return {}

		var logs = Util.queryFast(
			'SELECT g.game_name AS n, g.game_type AS t, l.log_date AS d, l.log_context AS c, l.game_id AS g' +
			' FROM log_user_collection l, game g' +
			' WHERE l.log_id IN(' + Util.in(index) + ')' +
			' AND l.game_id = g.game_id' +
			' ORDER BY g.game_sortname ASC'
		)
		var gameTrack = {}
		var games = []

		for (var i = 0; i < logs.length; i++) {
			var log = logs[i]
			var gameId = parseInt(log.g, 10)
			if (!gameTrack[gameId]) {
				gameTrack[gameId] = {
					id: gameId,
					t: parseInt(log.t, 10),
					added: 0,
					removed: 0,
					name: log.n
				}
			}
			gameTrack[gameId][parseInt(log.c, 10) === Constants.LOG_CONTEXT_ADDED ? 'added' : 'removed'] = parseInt(log.d, 10)
		}

		var ids = Object.keys(gameTrack)
		for (var j = 0; j < ids.length; j++) {
			var game = gameTrack[ids[j]]
			this._references.games.push(game.id)
			games.push({
				id: game.id,
				added: game.added,
				removed: game.removed
			})
		}

		return {
			games: games
		}
	}
})
